
export function setError (state, payload){
    state.error = true
    state.errorMessage = payload

}
export function setReporte(state, payload){
    state.reporte = payload.data.data
    state.error = false
}

export function flushReporte(state){
    state.reporte = ''
    state.error = false
}